// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/sfridi/lista?societaId',
    requestBody: null,
    response: '[{ formatoArticoloId, formatoNome, righe: [{ quantitaDa, quantitaA, sfrido }] }]'
  },
  {
    method: 'GET',
    endpoint: '/api/formati-articolo?societaId&q',
    requestBody: null,
    response: '[{ id, nome }]'
  },
  {
    method: 'DELETE',
    endpoint: '/api/sfridi?societaId&formatoArticoloId',
    requestBody: null,
    response: '{ success: true }'
  },
  {
    method: 'POST',
    endpoint: '/api/sfridi/salva',
    requestBody: '{ societaId, formatoArticoloId, righe }',
    response: '[{ id, quantitaDa, quantitaA, sfrido }]'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
